import type { FloatingFrame } from "./floating-frame-store";

/** Global logical coordinates keep adjacent displays aligned at mixed DPI. */
export function floatingFrameVisibleOnDisplay(
  frame: Pick<FloatingFrame, "displayId" | "dragging" | "box">,
  displayId: number | null,
  viewport: { x: number; y: number; width: number; height: number },
): boolean {
  if (frame.displayId === displayId) return true;
  return (
    frame.dragging &&
    frame.box.x < viewport.x + viewport.width &&
    frame.box.x + frame.box.width > viewport.x &&
    frame.box.y < viewport.y + viewport.height &&
    frame.box.y + frame.box.height > viewport.y
  );
}
